import React from 'react';
import {useTranslation} from 'react-i18next';
import {UseFormReturn} from 'react-hook-form';
import ImageSelectCompact from '../../../incase-domain/components/select/compact/image/ImageSelectCompact';
import ColorSelectCompact from '../../../incase-domain/components/select/compact/color/colorSelectCompact/ColorSelectCompact';
import {PresentationSettingsFormType} from '../../../incase-domain/validators/presentation/presentationSchema';
import {uploadImageFile} from '../../../service/files.service';

interface PresentationBackgroundSettingsFormProps {
    useForm: UseFormReturn<PresentationSettingsFormType>;
}

export default function PresentationBackgroundSettingsForm({useForm}: PresentationBackgroundSettingsFormProps): JSX.Element {
    const {t} = useTranslation();
    const {watch, setValue, getValues} = useForm;

    const backgroundColor = watch('presentation.backgroundColor');
    const backgroundImg = {
        image: watch('presentation.presentationBackground') ?? '',
        name: '',
    };
    const mobileBackgroundImg = {
        image: watch('presentation.presentationMobileBackground') ?? '',
        name: '',
    };

    function handleBackgroundImageChangeDesktop(
        color: string | null | undefined,
        desktopImage: {image: string; name: string} | null,
        mobileImage: {image: string; name: string} | null
    ): void {
        setValue('presentation.backgroundColor', color);
        setValue('presentation.presentationBackground', desktopImage?.image || '');
        setValue('presentation.presentationMobileBackground', mobileImage?.image || '');

        const updatedPresentation = {
            ...getValues('presentation'),
            backgroundColor: color,
            presentationBackground: desktopImage?.image || '',
            presentationMobileBackground: mobileImage?.image || '',
        };
        useForm.setValue('presentation', updatedPresentation);
    }

    return (
        <div className="l-group u-mt-2">
            <div className="u-flex u-flex-col u-gap-2">
                <ColorSelectCompact
                    label={t('presEditPage.themeModal.backgroundColor')}
                    color={backgroundColor}
                    onChange={(color) => handleBackgroundImageChangeDesktop(color, backgroundImg, mobileBackgroundImg)}
                />
                <ImageSelectCompact
                    label={t('presEditPage.themeModal.desktopImage')}
                    image={backgroundImg}
                    onChange={(desktopImage) => handleBackgroundImageChangeDesktop(backgroundColor, desktopImage, mobileBackgroundImg)}
                    onUpload={uploadImageFile}
                />
                <ImageSelectCompact
                    label={t('presEditPage.themeModal.mobileImage')}
                    image={mobileBackgroundImg}
                    onChange={(mobileImage) => handleBackgroundImageChangeDesktop(backgroundColor, backgroundImg, mobileImage)}
                    onUpload={uploadImageFile}
                />
            </div>
        </div>
    );
}
